import { AccountingAccount } from "../models/accounting.account.model";
import { Category } from "../models/category.model"
import { Contact } from "../models/contact.model";
import { InventoryReference } from "../models/inventory.reference.model";
import { Product } from "../models/product.model";
import { StorageCenter } from "../models/storage.center.model";
import { Service } from "../models/service.model";
import { TreasuryAccount } from "../models/treasury.account.model";
import { Tax } from "../models/tax.model";
import { Unit } from "../models/unit.model";
import { Names } from "../models/names.model";
import { BookingJournal } from "../models/booking.journal.model";
import { formatAccountingAccount, formatContact, formatContentDetail, formatTaxRate } from "./format.value.script";

export function taxRateCompany(list: Tax[], tax_method: string): string {
  let tax = list.find((item) => (item.code.toUpperCase() === tax_method.toUpperCase()))
  return tax ? ` : ${formatTaxRate(tax.rate)} %` : ''
}

export function measureUnitSelected(list: Unit[], id: string): string {
  let unit = list.find((item) => (item.id === id))
  return unit && unit.name ? unit.name.trim() : ''
}

export function contactSelected(list: Contact[], id: string): string {
  let contact = list.find((item) => (item.id === id))
  return contact ? formatContact(contact) : 'N/A'
}

export function treasuryAccountSelected(list: TreasuryAccount[], id: string): string {
  let treasury = list.find((item) => (item.id === id))
  return treasury ? treasury.name : 'N/A'
}

export function storageCenterSelected(list: StorageCenter[], id: string): string {
  let storage = list.find((item) => (item.id === id))
  return storage ? storage.name : 'N/A'
}

export function categorySelected(list: Category[], id: string): string {
  let category = list.find((item) => (item.id === id))
  return category ? category.display_name : 'N/A'
}

export function bookingJournalSelected(list: BookingJournal[], id: string, label: string): string {
  if (id === 'all') {
    return label
  } else {
    let journal = list.find((item) => (item.id === id))
    return journal ? journal.name : 'N/A'
  }
}

export function contentReferenceSelected(list: InventoryReference[], id: string, type: string): string {
  let reference = ((type === 'service') ? list.find(item => item.id_service === id) : list.find(item => item.id_variant === id))
  return reference ? formatContentDetail(reference) : '—'
}

export function taxFeeSelected(list: Tax[], id: string, company_language: string): string {
  let tax = list.find((item) => (item.code === id))
  return tax ? tax.label[company_language.toLowerCase() as keyof Names] : 'N/A'
}

export function accountingAccountSelected(list: AccountingAccount[], id: string, company_language: string): string {
  let account = list.find((item) => (item.id === id))
  return account ? formatAccountingAccount(account, company_language) : 'N/A'
}

export function serviceSelected(list: Service[], id: string): string {
  let service = list.find((item) => (item.id === id))
  return service ? `${service.code.length > 0 ? `${service.code}, ` : ''}${service.display_name}` : 'N/A'
}

export function productSelected(list: Product[], id: string): string {
  let product = list.find((item) => (item.variants.some((sub_item) => (sub_item.id === id))))
  let variant = product?.variants.find((item) => (item.id === id))
  return variant ? `${variant.code ? `${variant.code}, ` : ''}${product!.display_name} ${variant.description_short}` : 'N/A'
}
